import { parseDesktopAnalyticsContext, type DesktopAnalyticsContext } from '@padlet/desktop-shell-protocol/analytics'
import type { CaptureResult } from 'posthog-js'

function readDesktopAnalyticsContext(): DesktopAnalyticsContext | undefined {
  return parseDesktopAnalyticsContext(
    (window as Window & { padlet?: { analyticsContext?: unknown } }).padlet?.analyticsContext,
  )
}

function stampDesktopPostHogProperties(event: CaptureResult | null): CaptureResult | null {
  const desktop = readDesktopAnalyticsContext()
  if (event == null || desktop == null) return event
  return {
    ...event,
    properties: {
      ...event.properties,
      desktop_client: desktop.client,
      desktop_app_version: desktop.appVersion,
      desktop_build_version: desktop.buildVersion,
      desktop_distribution: desktop.distribution,
      desktop_environment: desktop.environment,
    },
  }
}

export { readDesktopAnalyticsContext, stampDesktopPostHogProperties }
